const StaticBuilderEnum = {
  STATIC_BUILDER_NAV_STEP_SET: 'STATIC_BUILDER_NAV_STEP_SET',
  STATIC_BUILDER_STEP_HISTORY_ADD: 'STATIC_BUILDER_STEP_HISTORY_ADD',
  STATIC_BUILDER_STEP_HISTORY_REMOVE: 'STATIC_BUILDER_STEP_HISTORY_REMOVE',
  STATIC_BUILDER_STEP_HISTORY_SET: 'STATIC_BUILDER_STEP_HISTORY_SET',
  STATIC_BUILDER_SECTION_KEYS_SET: 'STATIC_BUILDER_SECTION_KEYS_SET',
  STATIC_BUILDER_FIELD_OUTLINE_DATA_GET_SUCCESS: 'STATIC_BUILDER_FIELD_OUTLINE_DATA_GET_SUCCESS',
  STATIC_BUILDER_SESSION_CONTENT_GET_REQUEST: 'STATIC_BUILDER_SESSION_CONTENT_GET_REQUEST',
  STATIC_BUILDER_SESSION_CONTENT_GET_SUCCESS: 'STATIC_BUILDER_SESSION_CONTENT_GET_SUCCESS',
  STATIC_BUILDER_SESSION_CONTENT_GET_FAILURE: 'STATIC_BUILDER_SESSION_CONTENT_GET_FAILURE',
  STATIC_BUILDER_SECTION_CONTENT_SAVE_REQUEST: 'STATIC_BUILDER_SECTION_CONTENT_SAVE_REQUEST',
  STATIC_BUILDER_SECTION_CONTENT_SAVE_SUCCESS: 'STATIC_BUILDER_SECTION_CONTENT_SAVE_SUCCESS',
  STATIC_BUILDER_SECTION_CONTENT_SAVE_FAILURE: 'STATIC_BUILDER_SECTION_CONTENT_SAVE_FAILURE',
  STATIC_BUILDER_SECTION_LOAD_ACTION_ADD: 'STATIC_BUILDER_SECTION_LOAD_ACTION_ADD',
  STATIC_BUILDER_SECTION_CONDITIONALS_SET: 'STATIC_BUILDER_SECTION_CONDITIONALS_SET',
  STATIC_BUILDER_SECTION_LOAD_REQUEST: 'STATIC_BUILDER_SECTION_LOAD_REQUEST',
  STATIC_BUILDER_SECTION_LOAD_SUCCESS: 'STATIC_BUILDER_SECTION_LOAD_SUCCESS',
  STATIC_BUILDER_SECTION_LOAD_ERROR: 'STATIC_BUILDER_SECTION_LOAD_ERROR',
  STATIC_BUILDER_SECTION_CONDITIONALS_GET_REQUEST: 'STATIC_BUILDER_SECTION_CONDITIONALS_GET_REQUEST',
  STATIC_BUILDER_SECTION_CONDITIONALS_GET_SUCCESS: 'STATIC_BUILDER_SECTION_CONDITIONALS_GET_SUCCESS',
  STATIC_BUILDER_SECTION_CONDITIONALS_GET_FAILURE: 'STATIC_BUILDER_SECTION_CONDITIONALS_GET_FAILURE',
  STATIC_BUILDER_UPDATE_PREVIEW: 'STATIC_BUILDER_UPDATE_PREVIEW',
  STATIC_BUILDER_FIELD_OUTLINE_SET: 'STATIC_BUILDER_FIELD_OUTLINE_SET',
  STATIC_BUILDER_MENU_BUTTON_SET: 'STATIC_BUILDER_MENU_BUTTON_SET',
  STATIC_BUILDER_CREATE_ACCOUNT_MODAL_OPEN: 'STATIC_BUILDER_CREATE_ACCOUNT_MODAL_OPEN',
  STATIC_BUILDER_CREATE_ACCOUNT_MODAL_CLOSE: 'STATIC_BUILDER_CREATE_ACCOUNT_MODAL_CLOSE',
  STATIC_BUILDER_FORMSWIFT_LOGO_HAS_BEEN_CLICKED_SET: 'STATIC_BUILDER_FORMSWIFT_LOGO_HAS_BEEN_CLICKED_SET',
  STATIC_BUILDER_BACK_BUTTON_SET: 'STATIC_BUILDER_BACK_BUTTON_SET',
  STATIC_BUILDER_DOCUMENT_PREVIEW_HIDDEN_SET: 'STATIC_BUILDER_DOCUMENT_PREVIEW_HIDDEN_SET',
  STATIC_BUILDER_DOCUMENT_NAVIGATION_HIDDEN_SET: 'STATIC_BUILDER_DOCUMENT_NAVIGATION_HIDDEN_SET',
};

export default StaticBuilderEnum;



// WEBPACK FOOTER //
// ./src-react/StaticBuilder/StaticBuilderConstants.jsx